<template>
  <b-card class="chat-message">
    <span class="time">{{message.time_stamp | getMomentStr}}</span><br>
    <player-link :playerId="message.user_id" /><br>
    {{message.text}}
  </b-card>
</template>

<script>
import PlayerLink from '../PlayerLink.vue';

export default {
  name: 'MessageText',

  components: {
    PlayerLink,
  },

  props: {
    message: {
      type: Object,
      required: true,
    }
  },
};
</script>
